'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = '__multireducerKey';

exports.default = key;


//////////////////
// WEBPACK FOOTER
// ./~/multireducer/lib/key.js
// module id = 1155
// module chunks = 17 18 19